var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 16.3333H19C17.5333 16.3333 16.3333 17.5333 16.3333 19V32.3333C16.3333 33.8 17.5333 35 19 35H32.3333C33.8 35 35 33.8 35 32.3333V19C35 17.5333 33.8 16.3333 32.3333 16.3333ZM32.3333 19V21.6667H19V19H32.3333ZM24.3333 27V24.3333H27V27H24.3333ZM27 29.6667V32.3333H24.3333V29.6667H27ZM21.6667 27H19V24.3333H21.6667V27ZM29.6667 24.3333H32.3333V27H29.6667V24.3333ZM19 29.6667H21.6667V32.3333H19V29.6667ZM29.6667 32.3333V29.6667H32.3333V32.3333H29.6667ZM15 29.6667H13.6667C12.2 29.6667 11 28.4667 11 27V13.6667C11 12.2 12.2 11 13.6667 11H27C28.4667 11 29.6667 12.2 29.6667 13.6667V15H27V13.6667H13.6667V27H15V29.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.ebf9262236ae859af2d80e910a8b0943.svg";
export { ForwardRef as ReactComponent };